import styled from 'styled-components'

export const Wrap = styled.div`
  width: ${(props) => (props.wide ? '100%' : '800px')};
  margin: 0 auto;
  overflow-x: hidden;
`
